<template>
  <div class="border p-8 rounded shadow-2xl">
    <p class="text-STblue font-bold mb-2">Article preview</p>
    <div>
      <p class="uppercase font-OswaldFont text-2xl text-blue-900 my-auto">
        {{ form.header }}
      </p>

      <div class="flex mt-2">
        <img
          class="h-16 w-16 rounded-full my-auto"
          :src="authorImage"
          :alt="form.author"
        />
        <MarkdownPreview class="my-auto ml-2 text-lg" :text="form.author" />
      </div>

      <VimeoVideo class="mt-5" :link="form.link" :playVideo="true" />

      <MarkdownPreview class="mt-5" :text="form.body" />
    </div>
  </div>
</template>

<script>
import VimeoVideo from "../../VimeoVideo.vue";
import MarkdownPreview from "../../MarkdownPreview.vue";
import { generateFullPath } from "../../../utils/fileHelpers";

export default {
  name: "ArticlePreview",

  props: {
    preview: String,
    form: Object,
  },

  components: {
    MarkdownPreview,
    VimeoVideo,
  },

  computed: {
    authorImage() {
      return generateFullPath("/images/shottracker_author.png");
    },
  },
};
</script>
